import { render, staticRenderFns } from "./CodificationPage.vue?vue&type=template&id=0efb7e7c&"
import script from "./CodificationPage.vue?vue&type=script&lang=js&"
export * from "./CodificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports